<template>
  <div class="contentGroup" :style="{'margin-bottom' : marginBottom + 'px', 'margin-top' : marginTop + 'px'}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['marginBottom', 'marginTop']
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('contentGroup')
  background: #FFFFFF
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.05)
  max-width: 474px
  margin: 0 auto 25px
  border-radius: 35px
  display: flex
  justify-content: center
  box-sizing: border-box
  padding: 25px 25px 45px

</style>



// WEBPACK FOOTER //
// src/globalComponents/ContentGroup.vue